module.exports = __webpack_public_path__ + "img/building-2_fill.ac3bda5f.svg";